import { diaryByIdQueryOptions } from "@/features/diaries";
import { useWorklistCopy } from "@/features/i18n/worklistCopy";
import { WorklistCompleteDetailsPanel } from "@/features/worklist/components/WorklistCompleteDetailsPanel";
import { WorklistPanelHeader } from "@/features/worklist/components/WorklistPanelHeader";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const procedureKindSchema = z.enum(["injection", "surgery", "shockwave"]);

function WorklistDetailsPage() {
    const copy = useWorklistCopy();
    const { diaryId, eventId, procedureKind } = Route.useParams();
    const { diary } = Route.useLoaderData();
    const patientName = diary?.patient_info?.patient_name?.trim() || copy.unknownPatient;
    const taskLabel =
        procedureKind === "surgery"
            ? copy.surgeryDetailsTask
            : procedureKind === "shockwave"
              ? copy.shockwaveDetailsTask
              : copy.injectionDetailsTask;

    return (
        <div className="flex flex-col gap-4 p-2 md:p-3 pb-4" data-testid="worklist-details-panel">
            <WorklistPanelHeader title={taskLabel} subtitle={patientName} diaryId={diaryId} />
            <WorklistCompleteDetailsPanel diaryId={diaryId} eventId={eventId} procedureKind={procedureKind} />
        </div>
    );
}

export const Route = createFileRoute("/_app/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind")({
    component: WorklistDetailsPage,
    params: {
        parse: (params) => ({
            ...params,
            procedureKind: procedureKindSchema.parse(params.procedureKind),
        }),
        stringify: (params) => ({
            ...params,
            procedureKind: params.procedureKind,
        }),
    },
    loader: async ({ context, params }) => {
        const diary = await context.queryClient.ensureQueryData(diaryByIdQueryOptions(params.diaryId));
        return { diary };
    },
});
